<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong><span v-bind:class="'flag-icon flag-icon-us'" v-if="data.service.lang=='en'"></span><span v-bind:class="'flag-icon flag-icon-'+data.service.lang"
            v-if="data.service.lang!='en'"></span> บริการ : {{data.service.title}}</strong>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label v-if="data.service.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ data.service.created_at |
                moment('timezone', 'Asia/Bangkok', 'LLLL')}}</label>
              <label v-if="data.service.updated_at">&nbsp;&nbsp;<b>วันที่แก้ไข:</b> {{ data.service.updated_at |
                moment('timezone', 'Asia/Bangkok', 'LLLL')}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group row" v-if="data.service.image!=''">
            <div class="offset-lg-1 col-lg-10 text-center">
              <img v-bind:src="data.service.image" @error="imageLoadError" class="d-block w-full">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <p v-html="data.service.content"></p>
            </div>
          </div>
        </div>
        <div class="row mb-2" v-if="service.categories.selected.length>0">
          <div class="col-sm-12">
            <b>หมวดหมู่ที่เกี่ยวข้อง</b>
            <div class="row">
              <div v-for="category in service.categories.selected" :key="category.id">
                <b-btn @click="$router.push({ name: 'ServicesList',query: { category_id: category.id }})" class="mt-1 mx-1"
                  size="sm" variant="primary"><span v-html="category.name"></span></b-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="offset-lg-4 col-lg-4">
            <router-link :to="{ name: 'ServicesList'}"><button class="btn btn-info w-full" type="button"><i class="far fa-newspaper"></i>
                ดูบริการอื่นๆ</button></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        service: {
          id: parseInt(this.$route.query.id),
          categories: {
            options: [],
            selected: []
          }
        },
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          service: {
            title: '',
            image: '',
            content: '',
            lang: '',
            created_at: '',
            updated_at: '',
            categories: []
          }
        }
      }
    },
    methods: {
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      checkCategories() {
        let obj, val;
        for (val in this.data.service.categories) {
          for (obj in this.service.categories.options) {
            if (this.service.categories.options[obj].id == this.data.service.categories[val]) {
              this.service.categories.selected.push(this.service.categories.options[obj])
              break
            }
          }
        }
      },
      getServiceByID(id) {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/services/' + id, {
          params: {
            lang: this.data.service.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.service.title = response.body.json.title
            this.data.service.content = response.body.json.description
            this.data.service.image = response.body.json.image
            this.data.service.lang = response.body.json.locale
            this.data.service.categories = response.body.json.categories
            this.data.service.created_at = response.body.json.created_at
            this.data.service.updated_at = response.body.json.updated_at
            moment.locale(this.data.service.lang)
            this.checkCategories()
          }
        }, response => {
          this.failLoad()
        })
      },
      imageLoadError(event){
        this.data.service.image = ''
        event.target.src = this.no_image.src
      },
      getCategories() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/categories', {
          params: {
            lang: this.data.service.lang,
            per_page: 100
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.service.categories.options = response.body.json.data
          if (Number.isInteger(this.service.id)) {
            this.getServiceByID(this.service.id)
          }
          this.checkLoad()
        }, response => {
          this.failLoad()
        });

      }
    },
    mounted() {
      this.getCategories()
    }
  }

</script>
